// extracted by css-extract-rspack-plugin
export default {"cls1":"ClaimEvaluationRow-cls1_l8N","cls2":"ClaimEvaluationRow-cls2_Km- ClaimEvaluationRow-cls1_l8N"};